import { render, staticRenderFns } from "./verifyPayResult.vue?vue&type=template&id=2cd09f64&"
import script from "./verifyPayResult.vue?vue&type=script&lang=ts&"
export * from "./verifyPayResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports